import React, { ReactNode } from 'react';
import { Drawer as AntDrawer } from 'antd';
import style from './drawer.module.scss';
import lodash from 'lodash';
import { LoadingIcon } from '../icons/LoadingIcon';
import { ContentMode } from '../types';
import { usePermissions } from '../hooks';

type Props = {
	onClose: () => void;
	visible: boolean;
	onSave: () => void;
	isPreview: boolean;
	mode: ContentMode;
	loading: boolean;
	contentType: string;
	children: ReactNode;
};

export function Drawer(props: Props) {
	const { onClose, visible, children } = props;

	return (
		<div onClick={(e) => e.stopPropagation()}>
			<AntDrawer
				className="solo-chat-overrides"
				placement="right"
				closable={false}
				width="700"
				destroyOnClose
				onClose={onClose}
				visible={visible}
			>
				<div className={style.drawer}>
					<Header {...props} />
					{children}
				</div>
			</AntDrawer>
		</div>
	);
}

function Header(props: Props) {
	const canEdit = usePermissions('content.Edit')
	const { onSave, onClose, mode, loading, isPreview, contentType } = props;
	return (
		<div className={style.header}>
			<p>
				{mode === 'edit' ? 'Edit' : mode === 'view' ? 'View' : 'Add'}{' '}
				{lodash.startCase(contentType)}
			</p>
			<div className={style.headerActions}>
				<button onClick={onClose}>Cancel</button>

				{(!isPreview && (mode !== 'view' || mode === 'view' && canEdit)) && (
					<button disabled={loading} onClick={onSave}>
						{loading && <LoadingIcon width="14" height="14" stroke="#FFF" />}
						<span>{mode === 'view' ? 'Edit' : 'Save'}</span>
					</button>
				)}
			</div>
		</div>
	);
}
